/** @format */
import React, { FunctionComponent, useState, useEffect } from 'react'
import { Input, Icon, _$ } from 'kpc-react'

interface OwnProps {
  placeholder?: string
  value?: string
  prepend?: any
  width?: number
  onChange: (searchValue?: string) => void
}

const MonitorSearch: FunctionComponent<OwnProps> = ({
  placeholder,
  value,
  onChange,
  prepend,
  width
}) => {
  const [inputValue, setInputValue] = useState<string>(value || '')

  useEffect(() => {
    setInputValue(value)
  }, [value])

  return prepend ? (
    <Input
      clearable
      width={width}
      value={inputValue}
      Option
      onClear={() => {
        setInputValue('')
        onChange && onChange('')
      }}
      onKeyup={e => {
        if (e.keyCode === 13) {
          setInputValue(e.target.value)
          onChange && onChange(e.target.value)
        }
      }}
      on$change-value={(c, value) => {
        setInputValue(value)
      }}
      placeholder={placeholder ? _$(placeholder) : _$('输入查询')}
      b-suffix={
        <React.Fragment>
          <Icon
            className="k-icon-search cursor-pointer"
            onClick={() => {
              onChange && onChange(inputValue)
            }}
          />
        </React.Fragment>
      }
      b-prepend={prepend || undefined}
    ></Input>
  ) : (
    <Input
      clearable
      value={inputValue}
      width={width}
      Option
      onClear={() => {
        setInputValue('')
        onChange && onChange('')
      }}
      onKeyup={e => {
        if (e.keyCode === 13) {
          setInputValue(e.target.value)
          onChange && onChange(e.target.value)
        }
      }}
      on$change-value={(c, value) => {
        setInputValue(value)
      }}
      placeholder={placeholder ? _$(placeholder) : _$('输入查询')}
      b-suffix={
        <React.Fragment>
          <Icon
            className="k-icon-search cursor-pointer"
            onClick={() => {
              onChange && onChange(inputValue)
            }}
          />
        </React.Fragment>
      }
    ></Input>
  )
}

export default MonitorSearch
